import { ITransaction } from '../types';

export const getTransactionPayeeName = (transaction: ITransaction):string => transaction?.merchantName || transaction?.billerName || transaction?.prettyName || transaction?.details || '';
